export default {"src":"/_next/static/media/recently-sold.3f9e544e.svg","height":24,"width":24};